export default __webpack_public_path__ + "static/media/kara_live_show.d9bddf60.png";